import permissions from '@/store/modules/authentication/permissions'
import roles from '@/store/modules/authentication/roles'
import users from '@/store/modules/authentication/users'

const modules = {
  permissions,
  roles,
  users
}

export default {
  namespaced: true,
  modules
}
